import * as React from 'react';
import styled from 'styled-components';
import { themeGet, media } from '@packages/ui';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { NewsletterFooterContainer } from '@packages/shared';
import { SimpleNewsletter } from '../SimpleNewsletter';

const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

const ContentfulNewsletterWrapper = styled.div<{ newsletterBg: string; newsletterBgMobile: string }>`
  .newsletterContainer {
    ${({ newsletterBg }) => newsletterBg && `background: url(${newsletterBg}) repeat;`}
    ${({ newsletterBgMobile }) =>
      newsletterBgMobile &&
      `${media.to.md`
        background: url(${newsletterBgMobile}) repeat;`}
      `}
    background-size: cover;
    background-position: left;
    min-height: 171px;
    padding-bottom: 0;
  }

  .newsletterContentHolder {
    max-width: 300px;
    margin: 0 auto;
    ${media.from.md`
      max-width: 600px;
    `}
  }

  .textContainer {
    text-align: center;
    margin-bottom: 12px;
    margin-right: 0;

    h3 {
      margin-bottom: ${themeGet.space(2)};
      ${media.from.md`
        margin-bottom: ${themeGet.space(3)};
    `}
    }
  }

  .newsletterSubmitMsg {
    flex: 0 1 292px;
  }

  .newsletterFormElements {
    justify-content: center;
    ${media.to.md`
      flex-wrap: wrap;

      >div {
        margin-bottom: ${themeGet.space(2)};
      }
  `}
  }
`;

// TODO: check if in use
export const Newsletter: React.FC<{ tag: string; simple?: boolean }> = ({ tag, simple }) => {
  // TODO: check if they are correct
  const base = `${ASSETS_URL}/static/images`;
  const newsletterBg = `${base}/sea-bg.jpg`;
  const newsletterBgMobile = `${base}/sea-bg.jpg`;

  return simple ? (
    <SimpleNewsletter tag={tag}></SimpleNewsletter>
  ) : (
    <ContentfulNewsletterWrapper newsletterBgMobile={newsletterBgMobile} newsletterBg={newsletterBg}>
      <NewsletterFooterContainer showContentfulHeading={true} tag={tag} />
    </ContentfulNewsletterWrapper>
  );
};
